/**
 * Skeleton component type definitions
 */

export enum SkeletonSpeed {
  Slow = 'slow',
  Normal = 'normal',
  Fast = 'fast',
}

export enum SkeletonShape {
  Rectangle = 'rectangle',
  Circle = 'circle',
  Text = 'text',
}
